import { render, staticRenderFns } from "./dialog-uploadrelatedinbox.vue?vue&type=template&id=42e8b548&"
import script from "./dialog-uploadrelatedinbox.vue?vue&type=script&lang=js&"
export * from "./dialog-uploadrelatedinbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports